// extracted by mini-css-extract-plugin
export default {"commentInfo":"CoevaluationComment_commentInfo__7oI1b","commentInput":"CoevaluationComment_commentInput__X0-eD"};